import React from "react";

const DailyNoteIcon = (props: any) => {
  return (
    <div>
      <svg
        fill={props?.color ?? "black"}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="24px"
        height="24px"
        stroke={props?.color ?? "black"}
        stroke-width="0.00512"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <g>
            {" "}
            <g>
              {" "}
              <path d="M355.003,0H85.333v182.857H48.762V512h256v-36.571h158.476V108.236L355.003,0z M365.714,62.431l35.093,35.093h-35.093 V62.431z M268.19,475.429H85.333v-256H268.19V475.429z M426.667,438.857H304.762v-256H121.905V36.571h207.238v97.524h97.524 V438.857z"></path>{" "}
            </g>{" "}
          </g>{" "}
          <g>
            {" "}
            <g>
              {" "}
              <rect
                x="121.905"
                y="256"
                width="109.714"
                height="36.571"
              ></rect>{" "}
            </g>{" "}
          </g>{" "}
          <g>
            {" "}
            <g>
              {" "}
              <rect
                x="121.905"
                y="329.143"
                width="36.571"
                height="36.571"
              ></rect>{" "}
            </g>{" "}
          </g>{" "}
          <g>
            {" "}
            <g>
              {" "}
              <rect
                x="195.048"
                y="329.143"
                width="36.571"
                height="36.571"
              ></rect>{" "}
            </g>{" "}
          </g>{" "}
          <g>
            {" "}
            <g>
              {" "}
              <rect
                x="121.905"
                y="402.286"
                width="36.571"
                height="36.571"
              ></rect>{" "}
            </g>{" "}
          </g>{" "}
          <g>
            {" "}
            <g>
              {" "}
              <rect
                x="195.048"
                y="402.286"
                width="36.571"
                height="36.571"
              ></rect>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
    </div>
  );
};

export default DailyNoteIcon;
